import React from 'react';

const TranslatableTextarea = ({
    label,
    name,
    value,
    onChange,
    errors,
    placeholder,
    disabled,
    required = false,
    className = 'mb-3',
    rows = 3,
    selectedLanguage,
    selectedLang,
    ...props
}) => {
    const handleChange = (e) => {
        const { value: newValue } = e.target;
        onChange({
            target: {
                name,
                value: {
                    ...value,
                    [selectedLanguage]: newValue
                }
            }
        });
    };

    return (
        <div className={`${className}`}>
            {label && (
                <label className="form-label">
                    {label} ({selectedLang?.language})
                    {required && <span className="text-danger ms-1">*</span>}
                    {selectedLang?.default && <span className="ms-1 badge bg-primary">Default</span>}
                </label>
            )}
            <textarea
                name={name}
                value={value?.[selectedLanguage] || ''}
                onChange={handleChange}
                className={`form-control ${errors?.[`${name}.${selectedLanguage}`] || errors?.[name] ? 'is-invalid' : ''} ${className}`}
                placeholder={placeholder || `Enter ${label.toLowerCase()} in ${selectedLang?.language}`}
                disabled={disabled}
                dir={selectedLang?.direction || 'ltr'}
                rows={rows}
                {...props}
            />
            {(errors?.[`${name}.${selectedLanguage}`] || errors?.[name]) && (
                <div className="invalid-feedback">
                    {errors[`${name}.${selectedLanguage}`] || errors[name]}
                </div>
            )}
        </div>
    );
};

export default TranslatableTextarea; 